import ErrorNotifier from 'app/scripts/services/error-notifier';
import { all, put, takeEvery, call, fork } from 'redux-saga/effects';
import request from '@host-panel/request';
import {
  FETCH_ANALYTICS_OVERVIEW,
  fetchAnalyticsOverviewSuccess,
  fetchAnalyticsOverviewFailure
} from './index';

/**
 * @desc Business logic of effect.
 */
function* handleFetch(action): Generator {
  const { spotId, device, from_day, to_day, resolution, type } = action.payload;

  try {
    const response = yield call(request, `/host-panel/analytics-overview/${spotId}`, {
      method: 'GET',
      retries: 1,
      data: { device, from_day, to_day, resolution }
    });

    yield put(fetchAnalyticsOverviewSuccess(response, resolution, type));
  } catch (err) {
    yield put(fetchAnalyticsOverviewFailure(err));
    ErrorNotifier.notifyError(`Failed to fetch analytics data`, {
      device,
      from_day,
      to_day,
      resolution,
      type
    });
  }
}

/**
 * @desc Watches every specified action and runs effect method and passes action args to it
 */
function* watchFetchRequest(): Generator {
  yield takeEvery(FETCH_ANALYTICS_OVERVIEW, handleFetch);
}

/**
 * @desc saga init, forks in effects, other sagas
 */
export default function* analyticsSaga(): Generator {
  yield all([fork(watchFetchRequest)]);
}
